import React, { useState, useEffect, useMemo } from 'react';
import '@/pages/intelligence/assets/scss/MarketProfile/TabDetails/Overview.scss';
import { Bubble, Card } from 'tea-component';
import { history, useIntl, getLocale } from 'umi';
import HeadCard from '@/pages/intelligence/pages/MarketProfile/TabDetails/components/HeadCard';
import TotalMarket from '@/pages/intelligence/pages/MarketProfile/TabDetails/Overview/TotalMarket';
import MobileGameMarket from '@/pages/intelligence/pages/MarketProfile/TabDetails/Overview/MobileGameMarket';
import PCGameMarket from '@/pages/intelligence/pages/MarketProfile/TabDetails/Overview/PCGameMarket';
import ConsoleGameMarket from '@/pages/intelligence/pages/MarketProfile/TabDetails/Overview/ConsoleGameMarket';
import Filter, {
  IRangePickerConfig,
  ISegmentConfig,
} from '@/pages/intelligence/pages/MarketProfile/TabDetails/Overview/components/Filter';
import { pcHasDataCountry, getUrlParam } from '@/pages/intelligence/pages/MarketProfile/_util';
import { getCountryFlag } from '@/pages/home/_config/countries';
import useOverviewModal from '@intelligence/pages/MarketProfile/TabDetails/hooks/useOverviewModal.new';
import { testBaseInfo } from '@/pages/intelligence/pages/MarketProfile/_config/_detailTestData';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import { dbiBtnLogMes, dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import { debounce } from 'lodash-es';
import moment, { Moment } from 'moment';
import { useQueryDefinition } from '@intelligence/hooks/useQueryDefinition';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import { getCommonTimeFilterValues } from '@intelligence/pages/TopCharts/_config/topchartFilterCfg';

export default function MarketTabDetailsOverview(props: any) {
  const {
    marketName,
    actionFun,
    changeSegment,
    marketNameEn,
    pageId,
    jumpStat,
    NameMapFormBack,
    activeId,
  } = props;
  const [countryId, setCountryId] = useState('');
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const isEN = getLocale() === 'en-US';
  const { genreOptionsMap } = useQueryDefinition();

  const { isOperate, filterExtend } = useFilterExtend({});

  const {
    dataSearch,
    setCountryFlag,
    countryFlag,
    countryList,
    setMainSegment,
    onSegmentChange,
    time,
    dataSource,
    setDataSource,
    onChangeRangePicker,
    onChangeDataSource,
    summaryDataLoading,
    summaryTime,
    part1Data,
    mainSegment,
    part2Data,
    part3Data,
    newGameData,
    newGameLoad,
    newGameDate,
    topGameDataLoad,
    topGameTime,
    topGameTime2,
    topGameTime3,
    topGameTime4,
    topTotalGame,
    pcHasData,
    consoleHasData,
    topMobileGame10,
    topPCGame10,
    topConsoleGame10,
    topGenreData,
    topGenreDataLoad,
  } = useOverviewModal({ countryId });

  const isAnnie: any = useMemo(() => {
    return history.location.query?.isAnnie;
  }, [history.location]);

  const segmentOptions = [
    {
      text: formatMessage({ id: 'dbi_market_total' }),
      value: 'total',
    },
    {
      text: formatMessage({ id: 'dbi_market_mobile' }),
      value: 'mobile',
    },
    {
      text:
        pcHasDataCountry.indexOf(marketNameEn) == -1 ? (
          <Bubble
            dark
            arrowPointAtCenter
            placement="bottom"
            content={
              <div style={{ whiteSpace: 'pre-wrap', maxWidth: '400px' }}>
                The data for this game type is unavailable in current country or area.
                <br />
                此游戏类型的数据在当前国家或地区不可用。
              </div>
            }
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {formatMessage({ id: 'dbi_market_pc' })}
            </div>
          </Bubble>
        ) : (
          formatMessage({ id: 'dbi_market_pc' })
        ),
      value: 'pc',
      disabled: pcHasDataCountry.indexOf(marketNameEn) == -1,
    },
    {
      text:
        pcHasDataCountry.indexOf(marketNameEn) == -1 ? (
          <Bubble
            dark
            arrowPointAtCenter
            placement="bottom"
            content={
              <div style={{ whiteSpace: 'pre-wrap', maxWidth: '400px' }}>
                The data for this game type is unavailable in current country or area.
                <br />
                此游戏类型的数据在当前国家或地区不可用。
              </div>
            }
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                // fontSize: '12px',
              }}
            >
              {formatMessage({ id: 'dbi_market_console' })}
            </div>
          </Bubble>
        ) : (
          formatMessage({ id: 'dbi_market_console' })
        ),
      value: 'console',
      disabled: pcHasDataCountry.indexOf(marketNameEn) == -1,
    },
  ];

  const needSource = mainSegment === 'total' || mainSegment === 'mobile';

  useEffect(() => {
    const marketNameEn = marketNameEn || history.location.query?.marketNameEn;
    setCountryFlag(getCountryFlag(marketNameEn?.toUpperCase()));

    const gameType_url = history.location.query?.pageId;
    let type = 'mobile';
    const segmentFromOtherPage = getUrlParam('segment');
    if (segmentFromOtherPage == '') {
      if (countryList.indexOf(marketNameEn) != -1) {
        if (gameType_url == 'MarketProfilPC') {
          type = 'pc';
        } else if (gameType_url == 'MarketProfilConsole') {
          type = 'console';
        } else if (gameType_url == 'MarketProfilAnnualReport') {
          type = 'total';
        }
      } else if (gameType_url != 'MarketProfilMobile') {
        type = 'total';
      }
      changeSegment && changeSegment(type);
    } else {
      type = segmentFromOtherPage;
    }

    const source = history.location.query?.source || dataSource;

    const endDate = getCommonTimeFilterValues(filterExtend, 1);

    const _params = {
      market: marketNameEn,
      entity_type: type,
      start_date: endDate,
      end_date: endDate,
      // start_date: moment().format('YYYY-MM-DD'),
      // end_date: moment().format('YYYY-MM-DD'),
      source: needSource ? source : undefined,
    } as any;

    setMainSegment(type);
    setCountryId(marketNameEn);
    setDataSource(source);
    dataSearch(_params, true);
  }, []);

  // 跳转到stats页面
  const gotoMarketProfileStats = (title: string) => {
    // console.log('gotoMarketProfileStats', title);

    const segment = ['Mobile', '手游'].some((char) => title.includes(char))
      ? 'mobile'
      : title.includes('PC')
      ? 'pc'
      : 'console';
    // const pathStr = `/intelligence/marketProfile/Stats/detail?marketName=${marketName}&marketNameEn=${marketNameEn}&pageId=${pageId}&segment=${segment}${
    //   isAnnie ? `&isAnnie=${isAnnie}` : ''
    // }`;

    const params = new URLSearchParams({
      marketName,
      marketNameEn,
      pageId,
      segment,
    });

    // 可选 url 参数
    const optionalParams = { isAnnie };

    Object.entries(optionalParams).forEach(([key, value]) => {
      if (value !== undefined) params.set(key, value);
    });

    const pathStr = `/intelligence/marketProfile/Stats/detail?${params.toString()}`;

    jumpStat(pathStr);
  };

  // 跳转到游戏详情
  const gotoGameDetailsPage = (val: any, tab: string) => {
    buriedBtnPoint(dbiBtnLogMes.marketProfileStatsClickGame);
    const path = getDetailGamePathCommon({
      entityType: val.entity_type,
      gameId: val.unified_id,
      tab,
    });
    history.push(path);
  };

  const { scrollBody } = props;
  const [segmentFixed, setSegmentFixed] = useState(false);

  // 监听页面滚动
  useEffect(() => {
    if (scrollBody.current) {
      const handleScroll = debounce((e: any) => {
        const { scrollTop } = e.srcElement;
        // console.log(scrollTop);

        // 滚动判断距离 和定位条位置相关，开发调整
        if (scrollTop > 460) {
          setSegmentFixed(true);
        } else {
          setSegmentFixed(false);
        }
      }, 100);
      scrollBody.current?.addEventListener('scroll', handleScroll, false);
      return () => scrollBody.current?.removeEventListener('scroll', handleScroll, false);
    }
  }, [scrollBody]);

  const onSegmentChangeTrigger = (value: string) => {
    onSegmentChange(value);
    changeSegment(value);

    const needSource = value === 'total' || value === 'mobile';

    // history.replace(
    //   `/intelligence/marketProfile/${activeId}/detail?marketName=${marketName}&marketNameEn=${marketNameEn}&pageId=${pageId}&segment=${value}${
    //     isAnnie ? `&isAnnie=${isAnnie}` : ''
    //   }`,
    // )

    const params = new URLSearchParams({
      marketName,
      marketNameEn,
      pageId,
      segment: value,
    });

    // 可选 url 参数
    const optionalParams = {
      isAnnie,
      source: needSource ? dataSource : undefined,
    };

    Object.entries(optionalParams).forEach(([key, value]) => {
      if (value !== undefined) params.set(key, value);
    });
    const url = `/intelligence/marketProfile/${activeId}/detail?${params.toString()}`;
    history.replace(url);
  };

  const renderFilter = () => {
    return (
      <Filter
        segmentConfig={{
          mainSegment,
          segmentOptions,
          onSegmentChangeTrigger,
        }}
        rangePickerConfig={{
          time: time as Moment[],
          onChangeRangePicker,
          locale: locale === LANGUAGE_CN ? 'cn' : 'en',
        }}
        sourceSelectorConfig={{
          dataSource,
          onChangeDataSource,
        }}
      />
    );
  };

  return (
    <div className="dbi-market-tabdetails--overview">
      {testBaseInfo['2022'][countryId] ? (
        <Card className="dbi-market-tabdetails-header">
          <Card.Body>
            <HeadCard
              countryId={countryId}
              countryFlag={countryFlag}
              countryName={isEN ? marketName : NameMapFormBack[marketName] || marketName}
            />
          </Card.Body>
        </Card>
      ) : null}

      {renderFilter()}

      {/* 吸顶内容 */}
      <div className={`header-segment ${segmentFixed ? 'visible' : 'hide'}`}>{renderFilter()}</div>

      <div className="overview-cont">
        {mainSegment == 'total' ? (
          <TotalMarket
            summaryDataLoad={summaryDataLoading}
            summaryTime={summaryTime}
            part1Data={part1Data}
            mainSegment={mainSegment}
            actionFun={actionFun}
            dataSource={dataSource}
            part2Data={part2Data}
            part3Data={part3Data}
            newGameData={newGameData}
            newGameLoad={newGameLoad}
            newGameDate={newGameDate}
            topGameDataLoad={topGameDataLoad}
            topGameTime={topGameTime}
            topGameTime2={topGameTime2}
            topGameTime3={topGameTime3}
            topGameTime4={topGameTime4}
            topTotalGame={topTotalGame}
            pcHasData={pcHasData}
            consoleHasData={consoleHasData}
            gotoStats={gotoMarketProfileStats}
            gotoGameDetailsPage={gotoGameDetailsPage}
          />
        ) : mainSegment == 'mobile' ? (
          <MobileGameMarket
            entityType="mobile"
            summaryDataLoad={summaryDataLoading}
            summaryTime={summaryTime}
            part1Data={part1Data}
            mainSegment={mainSegment}
            actionFun={actionFun}
            dataSource={dataSource}
            part2Data={part2Data}
            part3Data={part3Data}
            newGameData={newGameData}
            newGameLoad={newGameLoad}
            newGameDate={newGameDate}
            topGameDataLoad={topGameDataLoad}
            topGameTime={topGameTime}
            topGameTime2={topGameTime2}
            topGameTime3={topGameTime3}
            topGameTime4={topGameTime4}
            topMobileGame10={topMobileGame10}
            pcHasData={pcHasData}
            consoleHasData={consoleHasData}
            topPCGame10={topPCGame10}
            topConsoleGame10={topConsoleGame10}
            topGenreData={topGenreData}
            topGenreDataLoad={topGenreDataLoad}
            genreOptionsMap={genreOptionsMap}
            gotoStats={gotoMarketProfileStats}
            gotoGameDetailsPage={gotoGameDetailsPage}
          />
        ) : mainSegment == 'pc' ? (
          <PCGameMarket
            summaryDataLoad={summaryDataLoading}
            summaryTime={summaryTime}
            part1Data={part1Data}
            mainSegment={mainSegment}
            actionFun={actionFun}
            part2Data={part2Data}
            part3Data={part3Data}
            newGameData={newGameData}
            newGameLoad={newGameLoad}
            newGameDate={newGameDate}
            topGameDataLoad={topGameDataLoad}
            topGameTime={topGameTime}
            topGameTime2={topGameTime2}
            topGameTime3={topGameTime3}
            topGameTime4={topGameTime4}
            topMobileGame10={topMobileGame10}
            pcHasData={pcHasData}
            consoleHasData={consoleHasData}
            topPCGame10={topPCGame10}
            topConsoleGame10={topConsoleGame10}
            topGenreData={topGenreData}
            topGenreDataLoad={topGenreDataLoad}
            gotoStats={gotoMarketProfileStats}
            gotoGameDetailsPage={gotoGameDetailsPage}
          />
        ) : (
          <ConsoleGameMarket
            summaryDataLoad={summaryDataLoading}
            summaryTime={summaryTime}
            part1Data={part1Data}
            mainSegment={mainSegment}
            actionFun={actionFun}
            part2Data={part2Data}
            part3Data={part3Data}
            newGameData={newGameData}
            newGameLoad={newGameLoad}
            newGameDate={newGameDate}
            topGameDataLoad={topGameDataLoad}
            topGameTime={topGameTime}
            topGameTime2={topGameTime2}
            topGameTime3={topGameTime3}
            topGameTime4={topGameTime4}
            topMobileGame10={topMobileGame10}
            pcHasData={pcHasData}
            consoleHasData={consoleHasData}
            topPCGame10={topPCGame10}
            topConsoleGame10={topConsoleGame10}
            topGenreData={topGenreData}
            topGenreDataLoad={topGenreDataLoad}
            gotoStats={gotoMarketProfileStats}
            gotoGameDetailsPage={gotoGameDetailsPage}
          />
        )}
      </div>
    </div>
  );
}
